module.exports = __webpack_public_path__ + "img/checkout-header.06759271.svg";